export default __webpack_public_path__ + "static/media/07.7d08a962.jpg";